module.exports = __webpack_public_path__ + "static/media/speed.3791ca06.svg";